import { Component, ComponentInterface, Element, Event, EventEmitter, h, Host, Prop, VNode } from '@stencil/core';

import { UniCommonColor, UniCommonSize, isString, isArray, isDefined } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

import { UniBreadcrumb } from '../models';

@Component({
  tag: 'uni-breadcrumbs',
  styleUrl: '../styles/breadcrumbs.css',
})
export class UniBreadcrumbsComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) icons: 'bs' | 'fa' | 'mat' = 'mat';

  @Prop({ reflect: true }) type: any;

  @Prop({ reflect: true }) name: string;

  @Prop({ reflect: true }) color: UniCommonColor;

  @Prop({ reflect: true }) size: UniCommonSize | number;

  @Prop({ reflect: true }) angle: number;

  @Prop() value: Partial<UniBreadcrumb>[] | string;

  @Event() uniBreadcrumbsRendered: EventEmitter<boolean>;

  render(): VNode {
    const { type, name, color, size, angle } = this;
    const iconProps = { type, name, color, size, angle };
    const UniIconsTag = `uni-icon-${this.icons}`;
    const value = isString(this.value) ? JSON.parse(this.value) : this.value;
    const path = isArray(value) ? value.filter((item: UniBreadcrumb): boolean => !!item?.name) : [];

    return (
      <Host class='uni-breadcrumbs'>
        {/*{path.length > 1*/}
        {/*  ? (<uni-router-link noParams={path[0].noParams} params={path[0].params}>*/}
        {/*    <uni-icons-mat name={'home'} color={this.color} className="uni-breadcrumbs-home"/>*/}
        {/*  </uni-router-link>)*/}
        {/*  : ''*/}
        {/*}*/}

        {path.map((item: Partial<UniBreadcrumb>, index: number) => path.length - 1 !== index
          ? isDefined(item.name)
            ? (<div class='uni-breadcrumbs'>
              {isDefined(item.path)
                ? <uni-router-link
                  ext={true}
                  params={item.params}
                  noParams={item.noParams}
                  reload={item.reload}
                  class='uni-breadcrumbs-link'
                >
                  <a href={item.path}>
                    {item.name}
                  </a>
                </uni-router-link>
                : item.name}

              {path[index + 1].name
                ? this.name ? <UniIconsTag {...iconProps} /> : <span class='uni-breadcrumbs-divider'> / </span>
                : ''}
            </div>)
            : ''
          : item.name,
        )}
        <slot />
      </Host>
    );
  }

  componentDidRender(): void {
    setTimeout(() => this.uniBreadcrumbsRendered.emit(true));
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
